import React from 'react';
import { OutlineButton } from '@/components/display/button';
import { ExecutePlanIcon } from '@/icons/execute-plan-icon';
import { useNavigate } from 'react-router-dom';
import { useCampaignContext } from '@/features/campaigns/campaign-context';
import { useStore } from '@/store/store';

export function ReviseExecutionButton() {
  const navigate = useNavigate();
  const { campaign } = useCampaignContext();
  const setDraftRevisions = useStore(state => state.setDraftRevisions);

  function handleClick() {
    setDraftRevisions(campaign.campaign_id, true);
    navigate(`/campaigns/${campaign.campaign_id}/proposal`);
  }

  return (
    <>
      <OutlineButton data-tooltip-id="generate-io" onClick={handleClick} className="cursor-pointer">
        <ExecutePlanIcon color={'blue'} />
        <div>Revise Execution Plan</div>
      </OutlineButton>
    </>
  );
}
